<template>
  <div>
    <h2 class="page-title-bar">
     <img class="ico" src="@/assets/img/ic_export_records.svg" alt="solum esl dashboard" /> {{ $t("Sensor Export Records") }}
    </h2>

    <!-- 검색창 -->
    <div class="searchArea">
      <v-text-field
        outlined
        dense
        hide-details
        v-model="searchBy.sensorCode"
        @keyup.enter="searchRecords"
        :label="$t('Sensor ID')"
        :placeholder="$t('Input Sensor ID')"
        class="form-input ml-3 col-2 mandatory"
        clearable
      ></v-text-field>
      <v-select
        :label="$t('Sensor Status')"
        :placeholder="$t('Select Sensor Status')"
        outlined
        dense
        hide-details
        v-model="searchBy.exportState"
        :items="exportStates"
        item-text="text"
        item-value="val"
        class="form-select ml-3 col-2 mandatory"
        clearable
      >
      </v-select>
      <v-btn text class="btn type-search ml-3" @click="searchRecords">{{
        $t("Search")
      }}</v-btn>
    </div>
    <v-data-table
      item-key="id"
      :headers="recordHeaders"
      :items="tableItems"
      :page.sync="page"
      :hide-default-footer="true"
      :options.sync="options"
      :server-items-length="totalRecords"
      class="tbl-type01 mt-10"

    >
      <template slot="no-data">
        <p>
          {{ $t("No data available") }}
        </p>
      </template>
      <template slot="item.download" slot-scope="props">
        <v-btn :disabled="props.item.exportState !== 'COMPLETED' || btnShowLogExport || props.item.count === 0" class="mx-2" icon @click="() => toDownloadSensorLogs(props.item)">
     <img class="ico_Sensor" :src="getExportIcon(props.item)" alt="solum esl dashboard" />
<!-- <img class="ico" src="@/assets/img/ic_export_records.svg" alt="solum esl dashboard" /> -->
        </v-btn>
      </template>
    </v-data-table>
    <!-- Button group -->
    <div class="table-options">
      <!-- Pagination -->

    </div>
        <Pagination @paging="paging($event)" :pageInfoText="pageInfoText" :pageIndex="pageIndex"
            :rowPerPage="rowPerPage" :goToPageInput="goToPageInput" :totalPages="totalPages"
            @updatePage="updatePage($event)"></Pagination>
        <!-- Hidden Link Element for Exporting -->
    <a ref="link" :style="{ display: 'none' }" />

    <!---- dialog for edit -->

    <!-- End -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/plugins/eventBus'
import { getRequestConfig } from '@/plugins/exporter'
import { setTempObj } from '@/plugins/sessionStorageManager'
import codes from '@/plugins/codes'
import commons from '@/plugins/commons'
import Pagenation from '@/mixins/Pagenation'
import Pagination from '@/components/pagination/Pagination.vue'
import axios from 'axios'
import configs from '@/plugins/configs'
import Cookies from 'js-cookie'

export default {
  name: 'SensorExportRecords',
  mixins: [Pagenation],
  components: {
    Pagination
  },
  data () {
    return {
      productionType: process.env.VUE_APP_PRODUCTION_TYPE,
      user: null,
      page: 1,
      totalPages: 0,
      totalVisiblePages: 7,
      pageInfoText: '',
      pageIndex: 1,
      rowPerPage: '10',
      totalpowerrails: null,
      options: {
        sortBy: ['initiatedDate'],
        sortDesc: [true]
      },
      requestConfig: {},
      tableItems: [],
      totalRecords: null,
      searchBy: {
        sensorCode: null,
        exportState: null
      },
      searchTerm: '',
      exportStates: [
        { text: this.$t('PROCESSING'), val: 'PROCESSING' },
        { text: this.$t('COMPLETED'), val: 'COMPLETED' },
        { text: this.$t('FAIL'), val: 'FAIL' },
        { text: this.$t('EXPIRED'), val: 'EXPIRED' }
      ]
    }
  },
  computed: {
    ...mapGetters({ store: 'dataStore/GET_SELECTED_STORE' }),
    recordHeaders () {
      return [
        {
          text: '#',
          sortable: false,
          align: 'center',
          value: 'index',
          width: '7%'
        },
        { text: this.$t('SENSOR ID'), value: 'sensorCode', sortable: false, width: '10%' },
        { text: this.$t('EXPORT STATE'), value: 'exportState', width: '10%' },
        { text: this.$t('COUNT'), value: 'count', width: '10%' },
        {
          text: this.$t('REQUSTED PERIOD'),
          value: 'requestedPeriod',
          width: '20%',
          sortable: false
        },
        { text: this.$t('STARTDATE'), value: 'initiatedDate', width: '15%' },
        {
          text: this.$t('COMPLETED DATE'),
          value: 'completedDate',
          width: '15%'
        },
        {
          text: this.$t('DOWNLOAD (Till 7 Days)'),
          sortable: false,
          value: 'download'
        }
      ]
    },
    deleteBtnDisabled () {
      return this.selected.length !== 1
    },
    exportDisabled () {
      let btnDisabled = this.btnShowProductExport
      if (!btnDisabled) {
        if (this.tableItems !== undefined) {
          btnDisabled = this.tableItems.length < 1
        } else {
          btnDisabled = true
        }
      }
      return btnDisabled
    }
  },
  watch: {
    options: {
      handler (newVal, oldVal) {
        console.log(newVal)
        if (newVal.page === oldVal.page) {
          this.getexporthistory(1)
          this.page = 1
        }
      },
      deep: true
    },
    searchBy: {
      handler (newSearchBy) {
        const updateRecords = {
          searchBy: newSearchBy
        }
        setTempObj('updateRecords', updateRecords)
      },
      deep: true
    },
    pageIndex: {
      handler (page) {
        this.goToPageInput = page
      }
    },
    store: {
      handler () {
        this.options.itemsPerPage = Number(this.rowPerPage)
        if (this.store.code !== '') {
          this.getexporthistory(1)
        }
        this.page = 1
      }
    }
  },
  mounted () {
    // button 권한 체크
    // Update Records : Export
    this.$store.dispatch('auth/getDisabledBtn', '13105').then(flag => {
      this.btnShowLogExport = flag
    })
    EventBus.$emit('enableSelectedStores', true)

    if (!this.store.code) {
      EventBus.$emit('openSelectedStores')
      this.getexporthistory(1)
    } else {
      this.getexporthistory(1)
    }
  },
  methods: {
    resetSearchCondition () {
      this.searchBy = {
        sensorCode: null,
        exportState: null
      }
      this.page = 1
      this.getexporthistory(1)
    },
    saveRequestConfig: function (config) {
      this.requestConfig = getRequestConfig(config)
    },
    buildSearchParams: function (params) {
      if (commons.isValidStr(this.searchBy.sensorCode)) {
        params.sensorCode = this.searchBy.sensorCode
      }
      if (commons.isValidStr(this.searchBy.exportState)) {
        params.exportState = this.searchBy.exportState
      }
      return params
    },
    buildParmas () {
      const { sortBy, sortDesc, itemsPerPage } = this.options
      let params = {
        store: this.store.code
      }
      params = this.buildSearchParams(params)
      let sort = null
      if (sortBy.length === 1 && sortDesc.length === 1) {
        const sortKey = sortBy[0]
        const sortOrder = sortDesc[0]
        sort = `${sortKey},${sortOrder ? 'desc' : 'asc'}`
      }
      if (sort !== null) params.sort = sort
      if (itemsPerPage > 0) params.size = this.rowPerPage
      return params
    },
    getexporthistory (page) {
      const params = this.buildParmas()
      if (page !== null) params.page = page - 1
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getSensorExportHistory.method,
          codes.requests.getSensorExportHistory.url,
          config
        )
        .then(res => {
          this.saveRequestConfig(res.config)
          this.tableItems = res.data.exportHistoryList.map(list => {
            list.initiatedDate = commons.convertDate(list.initiatedDate)
            list.completedDate = commons.convertDate(list.completedDate)
            const requestedPeriod = list.requestedPeriod
            const [fromDateStr, toDateStr] = requestedPeriod.split(' - ')
            const fromDate = commons.convertDate(fromDateStr)
            const toDate = commons.convertDate(toDateStr)
            list.requestedPeriod = fromDate + ' ~ ' + toDate
            list.index =
              res.data.exportHistoryList.indexOf(list) +
              1 +
              (page - 1) * res.data.exportHistoryList.length
            return list
          })
          this.totalRecords = res.data.exportHistoryList.length
          this.pageInfoText = this.getPageInfoText(res.headers)
          this.totalPages = Number(res.headers['x-totalpages'])
          this.selected = []
        })
        .catch(error => {
          this.tableItems = []
          this.totalRecords = this.tableItems.length
          const headers = {}
          headers['x-totalelements'] = 0
          this.pageInfoText = this.getPageInfoText(headers)
          this.totalPages = 0
          this.selected = []
          console.debug(`Could not find any update record ${error}`)
        })
    },
    getPageInfoText: function (headers) {
      if (headers['x-totalelements'] === 0) { return '0 to 0, 0' + ' ' + this.$t('in total') }
      return (
        `${headers['x-number'] * 1 * headers['x-size'] + 1} 
      ${this.$t('to')} ${headers['x-number'] * 1 * headers['x-size'] +
          headers['x-total-count'] * 1},
       ${headers['x-totalelements'] * 1}` +
        ' ' +
        this.$t('in total')
      )
    },
    paging (input) {
      this.goToPageInput = input
      this.getexporthistory(input)
    },
    updatePage (event) {
      this.rowPerPage = event.toString()
      this.paging(1)
    },
    searchRecords () {
      this.getexporthistory(1)
    },
    getExportIcon (item) {
      const isDisabled = item.exportState !== 'COMPLETED' || this.btnShowLogExport || item.count === 0
      return isDisabled
        ? require('@/assets/img/ic_download_sen.svg')
        : require('@/assets/img/ic_download_act_sen.svg')
    },
    async getRequestHeader () {
      const vuex = await JSON.parse(localStorage.getItem('vuex'))
      const session = Cookies.get('sessionId')

      const loginState = vuex.auth.loginState
      const hearder = {
      }
      const url = configs.ApiUrl
      if (url && url.toLowerCase().includes('https://')) {
        hearder['api-key'] = configs.ApiKey
      }
      if (loginState === true) hearder.sessionId = session
      if (configs.keycloakLogin === true) {
        hearder.Authorization = `Bearer ${vuex.auth.tokenAPI}`
      }
      return hearder
    },
    async toDownloadSensorLogs (data) {
      try {
        const headers = await this.getRequestHeader()
        const url = `/sensor/api/v1/export-history/${data.id}/download`

        const config = {
          headers: headers,
          responseType: 'blob'
        }

        const res = await axios.get(configs.ServerAddress + url, config)

        const disposition = res.headers['content-disposition']
        if (!disposition) {
          console.error('Content-Disposition missing')
          return
        }

        const fileName = disposition
          .split('filename=')[1]
          .replace(/"/g, '')
        const blob = res.data
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)
      } catch (err) {
        console.error('Download failed', err)
      }
    }
  }
}
</script>
<style scoped>
.downloadIcon {
  height: 15px;
  vertical-align: middle;
  position: relative;
  left: 21px;
  cursor: pointer;
}
.redbold {
  color: red;
  font-weight: bold;
}
.sensor-id-row {
  display: flex;
  align-items: center;
}
.sensor-id-label {
  font-weight: 600;
  margin-right: 8px;
}
.sensor-id-value {
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sensor-id-text {
  display: inline-block;
}
.muted {
  color: #888;
}
.date-row {
  display: flex;
  gap: 16px;
}
.date-col {
  flex: 1;
}
.form-select {
  width: 100%;
}
.field-label {
  display: block;
  font-size: 13px;
  color: #4b5563;
  margin-bottom: 6px;
}
.required-star {
  color: #d9534f;
  margin-left: 4px;
}
.export-note {
  background: #fff0f0;
  border-radius: 6px;
  padding: 12px 14px;
  color: #a33;
  display: flex;
  align-items: center;
}
.required-legend {
  font-size: 12px;
  color: #666;
}
.primary-btn {
  background: #052a45;
}
.btn + .btn {
  margin-left: 12px;
}
.dialog-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
}
.btn.cancel-btn {
  background: #0b2636;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
/* Apply button sizing and alignment inside date-picker popover */
.start-menu .v-card-actions,
.end-menu .v-card-actions {
  justify-content: flex-end !important;
  padding: 6px 10px !important;
  align-items: center;
}
.start-menu .v-card-actions .v-btn,
.end-menu .v-card-actions .v-btn {
  min-width: 72px !important;
  height: 34px !important;
  padding: 4px 12px !important;
  font-size: 13px !important;
  border-radius: 6px !important;
}
.start-menu .v-card-text,
.end-menu .v-card-text {
  padding-bottom: 6px !important;
}
.ico_Sensor {
    display: inline-block;
    width: 20px;
    height: 20px;
    /* margin-right: -15px; */
    vertical-align: top;
    text-align: center;
    align-items: center;
    background-position: top left;
    background-repeat: no-repeat;
    margin-left: 65px;
}
</style>
